import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { DiscoverService } from '../../service/discover.service';
import { commonService } from '../../service/common.service';
import {Globals } from '../../globals';
import { ForumsService } from '../../service/forums.service';

//declare var $: any;
@Component({
  selector: 'app-discoverpeople',
  templateUrl: './discoverpeople.component.html',
  styleUrls: ['./discoverpeople.component.css'],
  providers:[DiscoverService,ForumsService]
})

export class DiscoverpeopleComponent implements OnInit {

  obj:any;

  @Input() public postIndex;
  constructor(private forumsService:ForumsService,private global:Globals,private router:Router,private _discover:DiscoverService,private _common:commonService) { 
    this.obj ={};
    
  }

  ngOnInit() {
    this._common.profile.subscribe((data:any)=>{
      if(typeof data=='object' &&  data!=null){
        this.obj.userData = data;
      }else{
        this.obj.userData={};
        
      } 
   })

   this.getDiscoverPeopel();
  }
  

  getDiscoverPeopel(){

    var objdata  = {};
  

   objdata['userId']=(this.obj.userData.id?this.obj.userData.id:0);
   objdata['limit']=8;
   objdata['offset']= this.postIndex/8==1?0:this.postIndex/8*8;
   
    this._discover.getDiscoverPeopel(objdata).subscribe((data : any)=>{     
      if(data.error==0){
        this.obj.results=this.getArraytoCarousel(data.result);
      
        

       // this.obj.count=data.results.count
        

      }else{
        if(data.message=="Failed to authenticate token."){
          sessionStorage.clear();
          localStorage.clear();
          this.router.navigate(['/']);
        }else{
         this.obj.msg = data.message;
         this.obj.isError = true;
        }
      }
    },
    (error : HttpErrorResponse)=>{
    this.obj.isError = true;
    this.obj.msg="internal server error!";
    }); 


  }
  
getArraytoCarousel(arrayObj){
  var mainArray = [];
    var subArray = [];
  for(let obj in arrayObj){
    
    var objArray =  {};
    objArray=arrayObj[obj]
    subArray.push(objArray);
    if(subArray.length==4){
      mainArray.push(subArray);
      subArray = [];
    }
  }

  return mainArray;

}
getImagePath(path){
  if(!path){
    path='avatar.png';
  }
let res=this.global.profileUrl+path;
return res;

}


userFollower(user){
  if(Object.keys(this.obj.userData).length == 0){ 
    this._common.setLoginBox(true); 
    return false;
  } 

  let obj={}
  obj['f_userid']=(this.obj.userData.id)?this.obj.userData.id:0;
  obj['t_userid']=user.id;
  this.forumsService.userFollower(obj).subscribe((data:any)=>{
        if(data.error==0){
      
          if(data.result=='add'){
            if(parseInt(user.follower) == null){
              user.follower=0;
            }
            if(parseInt(user.ismyfollow) == null){
              user.ismyfollow=1;
            }
            
            user.follower = parseInt(user.follower) + 1;
            user.ismyfollow=1;
           // console.log(user);

          }else if(data.result=='sub'){
            if(parseInt(user.follower) == null){
              user.follower=0;
            }
            if(parseInt(user.ismyfollow) == null){
              user.ismyfollow=0;
            }
            
            user.follower = parseInt(user.follower) - 1;
            user.ismyfollow=0;
           // console.log(user);
          }
          
        }
  },(error:HttpErrorResponse)=>{
   // this.msg="internal server error!";
  })

}

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/discoverpeople/discoverpeople.component.ts